import LanguageIcon from "@mui/icons-material/Language";
import capitalize from "lodash/capitalize";

import { ProductGuideLanguageListNode } from "../../apiHooks/useProduct";
import { LabelValue } from "../../components/LabelValue";
import { useProductTranslation } from "../../hooks/useProductTranslation";

export type ProductGuideLanguageMetaDataProps = {
    languages: ProductGuideLanguageListNode[];
};

function useValue(guideLanguages: ProductGuideLanguageListNode[]) {
    const [t] = useProductTranslation();

    if (guideLanguages.length > 1) {
        return t("Multiple");
    } else if (guideLanguages.length == 1) {
        return capitalize(guideLanguages[0].name ?? "");
    }
    return;
}

export function ProductGuideLanguageMetaData({ languages }: ProductGuideLanguageMetaDataProps) {
    const value = useValue(languages);
    const [t] = useProductTranslation();
    const label = t("label.guideLanguage");
    return (
        <LabelValue label={label} Icon={LanguageIcon}>
            {value}
        </LabelValue>
    );
}
